import React from "react";
import Iconique from "./components/iconique/iconique";
import Tours9 from "./components/holes9/holes";
import Tours18 from "./components/holes18/holes";
import field from "../../../assets/images/2025-Program/golf-ball-flag.jpg";
import { Nav } from "../../../layouts/navbar/nav";
import { useTranslation } from "react-i18next";
import Header from "../../../layouts/header";

export default function Ranking() {
   const {i18n ,t} = useTranslation();
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
    return (
      <div className="mb-14">
        <Header image={field} title={t("ranking_content.rankings")}/>

        {/* Content Section */}
        <div className="flex flex-col items-center relative justify-center">
          <div
            className="px-4 md:px-[10rem] relative text-[#5a5a5a] text-base md:text-[20px] karla-font leading-relaxed tracking-wide"
            style={{ wordSpacing: "0.2rem" }}
          >
            {t("ranking_content.content")}
          </div>
          <div className="flex flex-col justify-center items-center mt-8 md:mt-14 w-full">
            <div className="w-full">
              <Iconique />
            </div>
            <div className="w-full">
              <Tours18 />
            </div>
            <div className="w-full">
              <Tours9 />
            </div>
          </div>
        </div>
      </div>
    );
}
